<template>
    <div class="AgentDetail p1" v-if="agent">
        <div style="height: 100%">
            <!--Header page-->
            <div class="header-page">
                <v-layout align-center class="py-12 px-16" style="height: 60px; border-bottom: 1px solid #E4EDFA;">
                    <!--Name bot-->
                    <div class="display-flex align-center">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <div v-if="agent" class="agent-name" v-on="on">
                                    {{ agent.name | capitalize }}
                                </div>
                            </template>
                            <span>{{ agent.name | capitalize }}</span>
                        </v-tooltip>
                    </div>
                    <v-spacer></v-spacer>
                    <v-menu
                        v-model="showMenuActions"
                        :close-on-content-click="false"
                        :nudge-width="180"
                        :nudge-right="-180"
                        :nudge-top="-6"
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div v-on="on" class="btn-icon-outline-3">
                                <v-icon color="#0052CC">mdi-dots-vertical</v-icon>
                            </div>
                        </template>
                        <v-list>
                            <div
                                v-for="(actionsItem, idxActions) in actionsList"
                                :key="`actions_${idxActions}`"
                            >
                                <v-list-tile
                                    v-for="action in actionsItem"
                                    :key="action.value"
                                    @click="handleActionsAgent(action.value)"
                                >
                                    <div class="centerY">
                                        <div class="centerY" style="width: 18px; padding-top: 2px">
                                            <img v-if="action.icon" :src="action.icon"
                                                 :alt="`icon_action_{item.value}`" style="width: 100%">
                                        </div>
                                        <div class="ml-8">{{ action.label }}</div>
                                    </div>
                                </v-list-tile>
                                <hr
                                    v-if="idxActions !== actionsList.length - 1"
                                    style="border: none; height: 1px; background-color: #d9d9d9; margin: 6px 0;"
                                />
                            </div>
                        </v-list>
                    </v-menu>
                </v-layout>

                <v-layout align-center class="py-8 px-16" style="border-bottom: 1px solid #E4EDFA;">
                    <!--Testing-->
                    <div @click="toggleTest" class="mr-8"
                         :class="showTest ? 'btn-custom' : 'btn-custom-normal btn-test'">
                        {{ showTest ? $f.tc('quitTest') : $f.tc('test') }}
                    </div>
                    <v-spacer></v-spacer>
                    <div @click="openInitCallDialog" class="btn-custom-normal mr-8">
                        {{ $f.tc('initCall') }}
                    </div>
                    <div @click="openEndCallDialog" class="btn-custom-normal mr-8">
                        {{ $f.tc('endCall') }}
                    </div>
                    <div @click="openAgentVariable" class="btn-custom-normal mr-8">
                        {{ $f.tc('variable') }}
                    </div>
                    <div @click="openAgentDictionary" class="btn-custom-normal mr-8">
                        {{ $f.tc('dictionary') }}
                    </div>
                    <div @click="openAgentFallback" class="btn-custom-normal mr-8">
                        {{ $f.tc('fallback') }}
                    </div>
                    <div @click="openAgentQuickReaction" class="btn-custom-normal mr-8">
                        {{ $f.tc('quickReaction.quickReaction') }}
                    </div>
                    <div @click="openInterruptSetting" class="btn-custom-normal mr-8">
                        {{ $f.tc('interrupt') }}
                    </div>
                    <div @click="openAgentSetting" class="btn-custom-normal mr-8">
                        {{ $f.tc('setting') }}
                    </div>
                </v-layout>
            </div>
            <!--Content-->
            <div class="p3" style="position: relative">
                <v-layout>
                    <!--Testing dialog-->
                    <div class="p4" :class="{active: showTest}">
                        <AgentTest ref="AgentTest" @update-test-var="updateTestVariable"
                                   @change-visibility="changeVisibilityOfVariableView"></AgentTest>
                    </div>
                    <!--Variable view-->
                    <div class="p4_1" :class="{active: showTest && childVisible}">
                        <AgentTestVariable :test-data="agentTestVariableData" :is-visible="childVisible"
                                           @change-visibility="changeVisibilityOfVariableView"></AgentTestVariable>
                    </div>
                    <!--Main content-->
                    <v-container class="centerY" style="position: relative">
                        <!--<AgentInfoConfig></AgentInfoConfig>-->
                        <img src="/img/welcome-agent.png" alt="icon-copy" class="center">
                    </v-container>
                </v-layout>
            </div>
        </div>
        <AgentVariable ref="AgentVariable"></AgentVariable>
        <AgentPermission ref="AgentPermission"></AgentPermission>
        <AgentSetting ref="AgentSetting"></AgentSetting>
        <AgentQuickReaction ref="AgentQuickReaction"></AgentQuickReaction>
        <AgentDictionary ref="AgentDictionary"></AgentDictionary>
        <AgentFallback ref="AgentFallback"></AgentFallback>
        <AgentInitCall ref="AgentInitCall"></AgentInitCall>
        <AgentEndCall ref="AgentEndCall"></AgentEndCall>
        <AgentInterrupt ref="AgentInterrupt"></AgentInterrupt>
    </div>
</template>
<script>
import {mapState} from "vuex";
import AgentService from "@/services/agent.service";
import AgentPermission from "@/views/Agent/AgentPermission.vue";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin.vue";
import AgentSetting from "@/views/Agent/AgentSetting.vue";
import AgentTest from "@/views/Agent/AgentTest.vue";
import AgentTestVariable from "./AgentTestVariable.vue";
import AgentQuickReaction from "@/views/Agent/AgentQuickReaction.vue";
import AgentVariable from "@/views/Agent/AgentVariable.vue";
import AgentDictionary from "@/views/Agent/AgentDictionary.vue";
import AgentFallback from "@/views/Agent/AgentFallback.vue";
import AgentInitCall from "@/views/Agent/AgentInitCall.vue";
import AgentEndCall from "@/views/Agent/AgentEndCall.vue";
import AgentInterrupt from "@/views/Agent/AgentInterrupt.vue";

const {AgentMode, AgentActions} = AgentService

export default {
    name: 'AgentDetail',
    mixins: [DialogPromiseFormMixin],
    components: {
        AgentTestVariable,
        AgentInterrupt,
        AgentEndCall,
        AgentFallback,
        AgentDictionary,
        AgentVariable,
        AgentQuickReaction,
        AgentSetting,
        AgentPermission,
        AgentTest,
        AgentInitCall,
    },
    data() {
        return {
            AgentMode,
            agentId: '',
            showMenuActions: false,
            showTest: false,
            agentTestVariableData: {},
            childVisible: false
        }
    },
    computed: {
        ...mapState({
            agent: state => state.agent.agent,
            roleEditable: () => AgentService.isEditable(),
            roleEditor: () => AgentService.isEditor(),
            roleAdminOrOwner: () => AgentService.isAdminOrOwner(),
            actionsList() {
                let actionsForEditor = [
                    [],
                    [
                        {
                            icon: '/img/audit.svg',
                            label: this.$f.tc('audit'),
                            value: AgentActions.AUDIT,
                        },
                        {
                            icon: '/img/history.svg',
                            label: this.$f.tc('history'),
                            value: AgentActions.HISTORY,
                        }
                    ]
                ]
                if (this.roleEditor) {
                    return actionsForEditor
                }

                if (this.roleAdminOrOwner) {
                    actionsForEditor[0].unshift({
                        icon: '/img/permission.svg',
                        label: this.$f.tc('managePermission'),
                        value: AgentActions.MANAGE_PERMISSION,
                    })
                    return actionsForEditor
                }

                return [
                    [{
                        icon: '/img/analytic.svg',
                        label: this.$f.tc('analytic'),
                        value: AgentActions.ANALYTIC,
                    }],
                    [{
                        icon: '/img/history.svg',
                        label: this.$f.tc('history'),
                        value: AgentActions.HISTORY,
                    }]
                ]
            },
            isEdit() {
                return AgentService.isEditable()
            },
        }),
    },
    mounted() {
        this.loadAgent()
        this.loadSetting()
    },
    methods: {
        loadAgent() {
            AgentService.CRUD.read(this.$route.params.agentId).then(
                result => {
                    this.$store.dispatch(this.$actionTypes.agent.SET_AGENT, result.data)
                }
            )
        },
        loadSetting() {
            AgentService.SettingService.search(this.$route.params.agentId).then(
                result => {
                    this.$store.dispatch(this.$actionTypes.agent.SET_SETTING, result.data)
                }
            )
        },
        handleActionsAgent(actionType) {
            switch (actionType) {
                case AgentActions.MANAGE_PERMISSION:
                    this.openManagePermissionEditor()
                    break
                case AgentActions.AUDIT:
                    this.goToAudit()
                    break
                case AgentActions.HISTORY:
                    this.openHistory()
                    break
            }
            this.showMenuActions = false
        },
        openAgentVariable() {
            this.$refs.AgentVariable.open()
        },
        openAgentDictionary() {
            this.$refs.AgentDictionary.open()
        },
        openAgentFallback() {
            this.$refs.AgentFallback.open()
        },
        openAgentQuickReaction() {
            this.$refs.AgentQuickReaction.open()
        },
        openAgentSetting() {
            this.$refs.AgentSetting.open()
        },
        openManagePermissionEditor() {
            this.$refs.AgentPermission.open(this.$route.params.agentId)
        },
        openHistory() {
            this.goToURL(`/agents/${this.$route.params.agentId}/history`)
        },
        goToURL(newURL) {
            if (this.$route.path !== newURL) {
                this.$router.push(newURL)
            }
        },
        toggleTest() {
            this.showTest = !this.showTest
            if (this.showTest) {
                this.$nextTick(() => {
                    if (this.$refs.AgentTest) {
                        this.$refs.AgentTest.start()
                    }
                })
            } else {
                this.childVisible = false
            }
        },
        openInitCallDialog() {
            this.$refs.AgentInitCall.open()
        },
        openEndCallDialog() {
            this.$refs.AgentEndCall.open()
        },
        openInterruptSetting() {
            this.$refs.AgentInterrupt.open()
        },
        changeVisibilityOfVariableView(isVisible) {
            this.childVisible = isVisible
        },
        updateTestVariable(newData, dataType) {
            if (dataType === 'bot') {
                this.agentTestVariableData = newData
                if (!this.childVisible) {
                    this.childVisible = true;
                }
            } else {
                if (this.childVisible) {
                    this.childVisible = false;
                }
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import "../Scenario/scenarioLayout";

.AgentDetail {
    height: calc(100vh - 62px);
    overflow: hidden;
    position: relative;
}

.agent-name {
    font-size: 22px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    max-width: 450px;
    font-family: "open sans bold", serif;
}

.header-page {
    background: #FFFFFF;
    //border-bottom: 1px solid #E4EDFA;
    //padding: 0 20px;
    overflow: auto;
    box-shadow: 3px 3px 6px #0000000D;
    //height: 63px;
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

.center {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
</style>
